module.exports = __webpack_public_path__ + "static/media/logo-white.d7018d2c.svg";